import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'

// ═══════════════════════════════════════════════════════════════════════════
// Types
// ═══════════════════════════════════════════════════════════════════════════

export interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Padding size */
  padding?: 'none' | 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

// ═══════════════════════════════════════════════════════════════════════════
// Component
// ═══════════════════════════════════════════════════════════════════════════

const paddingMap: Record<NonNullable<CardBodyProps['padding']>, string> = {
  none: '0',
  sm: '8px 16px',
  md: '12px 16px',
  lg: '16px',
}

/**
 * Controlled CardBody component.
 *
 * Content area for Card. Contains the main content like dropdowns.
 * All visual state determined by props. Spreads ...props for HOC injection.
 */
const CardBody = React.memo(
  ({ padding = 'md', children, style, className, ...props }: CardBodyProps) => {
    const [css] = useStyletron()

    const bodyClassName = css({
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: paddingMap[padding],
    })

    return (
      <div
        className={`${bodyClassName} ${className || ''}`}
        style={style}
        {...props}
      >
        {children}
      </div>
    )
  }
)

export default CardBody
